/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import AppNavTopLevel from '../../components/appNav/AppNavTopLevel';

const AppHeader = () => {
  return (
    <AppNavTopLevel hasDropShadow={false} />
  );
};

export default AppHeader;
